"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { ArrowRight, Star } from "lucide-react";

type Review = { id: string; author_name: string; rating: number; content: string; service_name: string };

export function ReviewsPreview() {
  const [reviews, setReviews] = useState<Review[]>([]);

  useEffect(() => {
    const controller = new AbortController();
    fetch("/api/reviews", { signal: controller.signal })
      .then((response) => response.ok ? response.json() : { reviews: [] })
      .then((data) => setReviews((data.reviews || []).slice(0, 3)))
      .catch(() => undefined);
    return () => controller.abort();
  }, []);

  return (
    <section className="section reviews-preview-section">
      <div className="container">
        <div className="section-heading gallery-heading"><div><p className="section-label">Avis clientes</p><h2>Des retours vérifiés</h2></div><Link href="/avis" className="text-link">Voir tous les avis <ArrowRight size={18} /></Link></div>
        {reviews.length ? <div className="review-preview-grid">{reviews.map((review) => <article key={review.id}><span className="review-stars">{Array.from({ length: 5 }, (_, index) => <Star key={index} size={16} fill={index < review.rating ? "currentColor" : "none"} />)}</span><p>“{review.content}”</p><strong>{review.author_name}</strong><small>{review.service_name}</small></article>)}</div> : <div className="empty-panel compact"><p>Les premiers avis validés apparaîtront ici.</p></div>}
      </div>
    </section>
  );
}
